export const GET_ALL_SIZE_REQUEST = "GET_ALL_SIZE_REQUEST";
export const GET_ALL_SIZE_FAILURE = "GET_ALL_SIZE_FAILURE";
export const GET_ALL_SIZE_SUCCESS = "GET_ALL_SIZE_SUCCESS";